import { render, staticRenderFns } from "./ExplainTip.vue?vue&type=template&id=1617112c&"
import script from "./ExplainTip.vue?vue&type=script&lang=js&"
export * from "./ExplainTip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports